<template>
  <div class>
    <v-toolbar dark color="primary">
      <v-toolbar-title>
        <v-icon class="icon">fa-user-slash</v-icon>Remove Users
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-toolbar dark color="secondary">
      <v-chip color text-color="white" @click="e1 = 1">
        <v-avatar>
          <!--<v-icon>account_circle</v-icon>-->
        </v-avatar>
        {{ selectedUserCount }} Selected Users
      </v-chip>
      <v-chip v-if="activeGroups" color text-color="white" @click="e1 = 2">
        <v-avatar>
          <!--<v-icon>supervised_user_circle</v-icon>-->
        </v-avatar>
        {{ selectedGroupCount }} Selected Groups
      </v-chip>
    </v-toolbar>
    <div id="slideout-container">
      <v-stepper v-model="e1" class="no-transition">
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1" step="1">Remove Users</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 2" step="2">Remove Groups</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1" class="max-height-list scroll-y">
            <h4 v-if="allUsersEnrolled">No users have been enrolled</h4>
            <v-text-field
              v-model="userSearch"
              v-if="!allUsersEnrolled"
              label="Filter Users By Name"
              type="text"
              @change="applyUserSearch"
            ></v-text-field>
            <v-data-table
              v-model="selectedUsers"
              v-if="!allUsersEnrolled"
              :headers="userHeaders"
              :options.sync="userOptions"
              :server-items-length="serverUserItemsLength"
              :loading="userLoading"
              :items="users"
              item-key="id"
              show-select
            ></v-data-table>
          </v-stepper-content>
          <v-stepper-content step="2" class="max-height-list scroll-y">
            <h4 v-if="allGroupsEnrolled">No groups have been enrolled</h4>

            <v-text-field
              v-if="!allGroupsEnrolled"
              v-model="groupSearch"
              label="Filter Groups By Name"
              type="text"
              @change="applyGroupSearch"
            ></v-text-field>
            <v-data-table
              v-if="!allGroupsEnrolled"
              v-model="selectedGroups"
              :headers="groupHeaders"
              :options.sync="groupOptions"
              :server-items-length="serverGroupItemsLength"
              :loading="groupLoading"
              :items="groups"
              item-key="id"
              show-select
            ></v-data-table>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
    <v-footer absolute height="100">
      <v-flex px-4 py-4 text-right>
        <div v-if="e1 == 1">
          <v-btn color="primary" class="mr-1" @click="closePanel">Cancel</v-btn>
          <v-btn color="primary" @click="e1 = 2">Next</v-btn>
        </div>
        <div v-if="e1 == 2">
          <v-btn color="primary" class="mr-1" @click="e1 = 1">Back</v-btn>
          <v-btn v-if="loading" color="primary" loading></v-btn>
          <v-btn v-else color="primary" @click="removeUsers">Remove Selected</v-btn>
        </div>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import courseAPI from "@/api/course.js";
import userAPI from "@/api/user.js";
import groupAPI from "@/api/group.js";
import DatePicker from "@/components/admin/global/Datepicker";
export default {
  name: "RemoveUsers",
  components: {
    DatePicker
  },
  props: {
    id: {
      type: String,
      default: null
    },
    params: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      userHeaders: [
        { text: "First Name", value: "first_name" },
        { text: "Surname", value: "last_name" },
        { text: "Email", value: "email" }
      ],
      groupHeaders: [
        { text: "Name", value: "name" },
        { text: "Description", value: "description" }
      ],
      loading: false,
      e1: 1,
      selectedUsers: [],
      selectedGroups: [],
      userSearch: "",
      groupSearch: "",
      users: [],
      groups: [],
      userSearchParams: "",
      groupSearchParams: "",
      userOptions: {},
      groupOptions: {},
      userLoading: false,
      groupLoading: false,
      userPagination: {},
      groupPagination: {},
      selectedDate: "Not Set",
      deadlineSet: false,
      successMessage: "Users Successfully Enrolled.",
      errorMessage: "Oops, something went wrong!",
      nothingSelected: "You havent selected any Users or Groups.",
      deadlineNotSet: "You havent set a Deadline.",
      allUsersEnrolled: false,
      allGroupsEnrolled: false
    };
  },
  computed: {
    serverUserItemsLength: function() {
      return this.userPagination.total;
    },
    userItemsPerPage: function() {
      return this.userPagination.per_page;
    },
    userPage: function() {
      return this.userPagination.current_page;
    },
    userParams: function() {
      return this.$gf.getQueryString(this.userOptions);
    },
    selectedUsersTotal: function() {
      return this.selectedUsers.length;
    },
    serverGroupItemsLength: function() {
      return this.groupPagination.total;
    },
    groupItemsPerPage: function() {
      return this.groupPagination.per_page;
    },
    groupPage: function() {
      return this.groupPagination.current_page;
    },
    groupParams: function() {
      return this.$gf.getQueryString(this.groupOptions);
    },
    selectedGroupsTotal: function() {
      return this.selectedGroups.length;
    },
    activeUsers: function() {
      return this.users.length > 0 ? true : false;
    },
    activeGroups: function() {
      return this.groups.length > 0 ? true : false;
    }
  },
  watch: {
    userOptions: {
      handler() {
        this.getEnrolledUsers();
      },
      deep: true
    },
    groupOptions: {
      handler() {
        this.getEnrolledGroups();
      },
      deep: true
    }
  },
  mounted() {
    this.setEventBus();
  },
  methods: {
    getEnrolledUsers() {
      this.userLoading = true;
      courseAPI
        .getCourseEnrolledIndividualUsers(this.id, this.userParams, this.userSearchParams)
        .then(resp => {
          this.users = resp.data.data;
          this.userPagination = resp.data.meta.pagination;
          this.userLoading = false;
          this.users.length == 0
            ? (this.allUsersEnrolled = true)
            : (this.allUsersEnrolled = false);
        });
    },
    getEnrolledGroups() {
      this.groupLoading = true;
      courseAPI
        .getCourseEnrolledGroups(
          this.id,
          this.groupParams,
          this.groupSearchParams
        )
        .then(resp => {
          this.groupLoading = false;
          this.groups = resp.data.data;
          this.groupPagination = resp.data.meta.pagination;
          this.groups.length == 0
            ? (this.allGroupsEnrolled = true)
            : (this.allGroupsEnrolled = false);
        });
    },
    applyUserSearch() {
      this.userSearchParams =
        this.userParams +
        "&search=first_name:" +
        this.userSearch +
        ";last_name:" +
        this.userSearch;
      this.getUsers();
    },
    applyGroupSearch() {
      this.groupSearchParams =
        this.groupParams + "&search=name:" + this.groupSearch;
      this.getGroups();
    },
    processSelectedUsers() {
      let users = [];
      this.selectedUsers.forEach(function(x) {
        users.push(x.id);
      });
      return users;
    },
    processSelectedGroups() {
      let groups = [];
      this.selectedGroups.forEach(function(x) {
        groups.push(x.id);
      });
      return groups;
    },
    removeUsers() {
      this.loading = true;
      courseAPI
        .removeUsersAndGroups(this.id, {
          users: this.processSelectedUsers(),
          groups: this.processSelectedGroups(),
        })
        .then(() => {
          EventBus.$emit("COURSES_UPDATED", this.params);
          this.closePanel();
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(() => {
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    setEventBus() {
      EventBus.$on("DATE_SELECTED", date => {
        this.deadlineSet = true;
        this.selectedDate = date;
      });
    },
    closePanel() {
      this.$emit("closePanel", {});
    }
  }
};
</script>
<style media="screen">
#slideout-container {
  height: calc(100vh - 65px - 100px);
}
.max-height-list {
  height: calc(100vh - 65px - 100px - 48px);
}
.no-transition .stepper__content {
  transition: none;
}
</style>
